import { IMonth } from 'common/types';
import { AppState } from '../store';
import { BudgetMonthBase } from 'common/entities';
import { BudgetMonthState } from '../reducers/budgetMonth.reducer';

export const budgetMonthSelector =
  (month: IMonth) =>
  (
    state: AppState
  ): BudgetMonthState & BudgetMonthBase & { budgetMonthCreated: boolean } => {
    const targetPeriod = state.budgetMonthReducer.monthBudgetDetails.find(
      mb => mb.month === month.month && mb.year === month.year
    );

    return targetPeriod
      ? {
          ...state.budgetMonthReducer,
          ...targetPeriod,
          budgetMonthCreated: true
        }
      : {
          ...state.budgetMonthReducer,
          month: month.month,
          year: month.year,
          prevPeriodResidue: 0,
          budgetMonthCreated: false
        };
  };
